import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Flex, Modal } from 'antd';
import { login } from '../api/api'; // Importamos la función login
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();

  const [modal, modalContextHolder] = Modal.useModal();

  const onFinish = async ({ username, password }) => {
    const { success, message: errorMessage } = await login(username, password);
    if (success) {
      navigate('/home');
    } else {
      modal.info({
        title: 'Acceso',
        content: errorMessage,
      });
    }
  };

  return (
    <div className="login-background">
      <Flex
        className="login-flex"
        vertical
      >
        <Card className="login-card">
          {modalContextHolder}
          <div className="logo-container">
            <img
              src="/favicon.png"
              alt="Logo"
              className="logo"
            />
          </div>
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            layout="vertical"
          >
            <Form.Item
              label={<span className='ant-form-item-label'>Cédula</span>} 
              name="username"
              rules={[
                { required: true, message: 'Por favor ingresa su cédula' },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={<span className='ant-form-item-label'>Contraseña</span>}
              name="password"
              rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}>
              <Input.Password />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                INICIAR SESIÓN
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Flex>
    </div>
  );
};

export default LoginPage;
